import styled from "styled-components";

export const TrustSection = styled.section`
  padding: 2rem 0 6rem;
`;

export const TrustGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

export const TrustCard = styled.article`
  text-align: center;
  padding: 2rem 1.5rem;
  background: ${(props) => props.theme.colors.white_100};
  border-radius: 20px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0f0f0;

  .icon-wrap {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    margin: 0 auto 1.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
  }

  h3 {
    font-family: "SatoshiBold", sans-serif;
    font-size: 1.1rem;
    margin: 0 0 0.75rem;
    color: ${(props) => props.theme.colors.balck_200};
    font-weight: 700;
  }

  p {
    font-family: "SatoshiRegular", sans-serif;
    font-size: 0.9rem;
    line-height: 1.55;
    color: #666;
    margin: 0;
  }
`;
